import axios from "axios";
// import { Toast } from "mint-ui"; // 我用的mint的框架来弹出我的错误返回 大家可以用别的提示（移动端的组件库）
import {Message} from 'element-ui';
import store from '../store'
import {decryptSuccessMix} from './common.js'

// 默认超时设置
axios.defaults.timeout = 5000;

// 相对路径设置
// axios.defaults.baseURL = "https://rockysports.cn/api/";

//http request 拦截器
axios.interceptors.request.use(
  (config) => {
    // 获取token
    const token = sessionStorage.getItem("token");
    // 设置参数格式
    if (!config.headers["Content-Type"]) {
      config.headers = {
        // "Content-Type": "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      };
    }
    // 添加token到headers
    if (token) {
      config.headers.token = token;
    }

    // 鉴权参数设置
    if (config.method === "get") {
      //get请求下 参数在params中，其他请求在data中
      config.params = config.params || {};
      let json = JSON.parse(JSON.stringify(config.params));
      //一些参数处理
      config.params.api_token = localStorage.getItem('api_token')
    } else {
      config.headers = {
        "Content-Type": "application/json",
      };
      config.data = config.data || {};
      //一些参数处理
      config.data.api_token = localStorage.getItem('api_token')
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    // console.log('拦截器');
    //一些统一code的返回处理
    if (response.code == 401) {

      // 登录验证
      //做了个示例跳转项目中登录，并记录下相对路径
      router.replace({path:`/login?redirect=${router.currentRoute.fullPath}`})
      // router.push({
      //   name: "login", //从哪个页面跳转
      //   query: {
      //     redirect: window.location.href.split("#")[1] || "",
      //     is_new_user_url: 1,
      //   },
      // });
    }
    if(response.headers['0-0'] == 1){
      response.data = decryptSuccessMix(response.data)
    }
    if(response.data.msg.code == 0){
      return response.data;
    }else{
      Message.error(response.data.msg.info)
      return Promise.reject(response.data.msg);
    }
  },
  (error) => {
    // console.log('拦截器'+ error.response.status);
    if (error.response.status == 401) {

      sessionStorage.clear()
      store.commit('clearVUEX')
      router.push("/login");
    }
    return Promise.reject(error);
  },


);

export default axios



// WEBPACK FOOTER //
// ./src/assets/axios.js